import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const NotificationActivityRoute = lazyWithRetries(() => import('.'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.notificationActivity(),
    element: (
      <StandardPageLayout
        elementId="notificationsRoute"
        maxWidth={1080}
        title={<T _str="Activity" />}>
        <Suspense fallback={<RouteLoading />}>
          <NotificationActivityRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
